export default "__VITE_ASSET__V61NtfV2__"